import { Loader } from '@/components/layout/loading';
import { Wizard } from '@/components/wizard/Wizard';
import { useDAL } from '@/contexts/useDAL';
import { useUser } from '@/contexts/useUser';
import { useWorkspace } from '@/contexts/useWorkspace';

import { SetupOwnCloudSourceFlow } from './SetupOwnCloudSourceFlow';
import { type SetupOwnCloudState } from './SetupOwnCloudState';

export default function SetupOwnCloudSourceWizard({
  recalculateAccounts,
}: {
  recalculateAccounts: () => void;
}) {
  const { rightPanel } = useWorkspace();
  const { currentProjectId, eonAccount } = useUser();
  const dal = useDAL();
  const { data: backupApps, isLoading } =
    dal.onboarding.applications.get('Source');

  const onFinish = async () => {
    recalculateAccounts();
    return true;
  };

  // Show loading state while backupApps data is being fetched
  if (isLoading || !backupApps) {
    return <Loader />;
  }

  return (
    <Wizard<SetupOwnCloudState>
      hideCloseButton={false}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={true}
      onFinish={onFinish}
      flow={[SetupOwnCloudSourceFlow]}
      title='Connect Azure source account'
      subtitle='Connect your source account and grant Eon access to discover resources for backup management.'
      persistState={true}
      storageKey={`setup-own-cloud-source`}
      initialState={{
        onboardingFlow: false,
        tenantId: backupApps.customerTenantId,
        eonAccountId: eonAccount?.id,
        projectId: currentProjectId,
        sourceConnectType: 'subscription',
        managementApplicationId: backupApps.managementAppId,
        backupAppId: backupApps.backupAppId,
        keyVaultApplicationId: backupApps.keyVaultAccessAppId,
        regionName: 'eastus2',
      }}
    />
  );
}
